import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "SearchBox" })
export default class SearchBox extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public searchtext: string = null;
    public suggestionSearchList: any[] = [];
    public results: any[] = [];
    public suggestions: any[] = [];
    public searchIndex: number = -1;
    public debounceTimeOut: any = null;
    public lockLoader: boolean = false;
    public isVisible: boolean = true;

    @Prop() readonly documentationName: string;
    @Prop() readonly documentationSlug: string;
    @Prop() readonly mode: string;

    @Watch("searchtext") onSearchTextChanged() {
        this.debounceSearchText(500);
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        if (!navigator.onLine) {
            this.isVisible = false;
        }

        const outsideClickListener = event => {
            if (!this.$el.contains(event.target)) {
                this.resetSearchtext();
            }
        }

        document.addEventListener("click", outsideClickListener);
    }

    public async debounceSearchText(delay: number) {
        const vm = this;
        if (!this.lockLoader) {
            this.isLoading = true;
        }

        clearTimeout(this.debounceTimeOut);
        this.debounceTimeOut = setTimeout(async function (context) {
            if (vm.searchtext?.length >= 3) {
                await vm.getSuggestions();
            } else {
                vm.suggestions = [];
                vm.searchIndex = -1;
                vm.isLoading = false;
                vm.lockLoader = false;
            }
        }, delay, this);
    }

    public async getSuggestions() {
        try {
            const response = (await Axios.post(this.routes.Search_GetSuggestions, { searchtext: this.searchtext, documentationName: this.documentationName, documentationSlug: this.documentationSlug })).data;

            this.results = response.results;
            this.suggestions = response.suggestions;
            this.searchIndex = -1;

            if (this.results.length !== 0) {
                this.suggestionSearchList = this.results;
            }

            if (this.results.length === 0) {
                this.suggestionSearchList = this.suggestions;
            }

            for (let index = 0; index < this.suggestionSearchList.length; index++) {
                this.suggestionSearchList[index].index = index;
            }
        } catch (error) { }

        this.isLoading = false;
        this.lockLoader = false;
    }

    public openDetailUrlByIndex() {
        if (this.results.length === 0) {
            this.setSearchText(this.suggestionSearchList.find(x => x.index === this.searchIndex)?.text);
            return;
        }

        if (this.searchIndex === -1 || this.suggestionSearchList.length === 0) {
            return;
        }

        (<any>window)._paq?.push(["trackEvent", "Search", "Click", this.suggestionSearchList.find(x => x.index === this.searchIndex).url]);

        window.location.href = this.setDocumentationUrl(this.suggestionSearchList.find(x => x.index === this.searchIndex).url);
    }

    public resultMoveDown() {
        if (this.suggestionSearchList.length !== 0 && this.searchIndex < this.suggestionSearchList.length - 1) {
            this.searchIndex++;
        }
    }

    public resultMoveUp() {
        if (this.suggestionSearchList.length !== 0 && this.searchIndex > 0) {
            this.searchIndex--;
        }
    }

    public setSearchText(searchText: string) {
        this.lockLoader = true;
        this.searchtext = searchText;
        (<any>window)._paq?.push(["trackEvent", "Search", "Click", 'QuerySuggest_' + searchText]);
    }

    public resetSearchtext() {
        this.searchtext = null;
        this.results = [];
        this.suggestions = [];
        this.suggestionSearchList = [];
        this.searchIndex = -1;
    }

    public setDocumentationUrl(url: string) {
        if (this.mode === "Embed") {
            url += "?mode=Embed";
        }
        return url;
    }

    public setMatonoEvent(url: string) {
        (<any>window)._paq?.push(["trackEvent", "Search", "Click", url]);
    }
};